import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "clearfix"
}
const _hoisted_2 = {
  key: 1,
  class: "card mb-25 border-0 rounded-0 bg-white letter-spacing"
}
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_6 = { class: "table-responsive" }
const _hoisted_7 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_8 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
}
const _hoisted_9 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_10 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_11 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_12 = {
  scope: "col",
  class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
}
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis title ps-0" }
const _hoisted_14 = { class: "d-flex align-items-center" }
const _hoisted_15 = { class: "d-flex align-items-center ms-5 fs-md-15 fs-lg-16" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_19 = { class: "shadow-none lh-1 fw-medium" }
const _hoisted_20 = {
  key: 0,
  class: "badge text-outline-success"
}
const _hoisted_21 = {
  key: 1,
  class: "badge text-outline-danger"
}
const _hoisted_22 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = { class: "dropdown-menu" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  class: "modal fade",
  id: "companyModal",
  tabindex: "-1",
  "aria-hidden": "true"
}
const _hoisted_29 = { class: "modal-dialog modal-lg modal-dialog-centered" }
const _hoisted_30 = { class: "modal-content" }
const _hoisted_31 = { class: "modal-header" }
const _hoisted_32 = { class: "modal-title fs-5" }
const _hoisted_33 = { class: "modal-body" }
const _hoisted_34 = {
  key: 0,
  style: {"margin-top":"5%"}
}
const _hoisted_35 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_36 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"red"}
}
const _hoisted_37 = {
  key: 1,
  style: {"margin-top":"5%"}
}
const _hoisted_38 = {
  class: "text-red fw-bold mb-0 text-center",
  style: {"color":"green"}
}
const _hoisted_39 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_40 = { class: "row" }
const _hoisted_41 = { class: "col-md-6" }
const _hoisted_42 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_43 = ["placeholder"]
const _hoisted_44 = { class: "invalid-feedback" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_47 = {
  key: 0,
  value: "AVAILABLE"
}
const _hoisted_48 = {
  key: 1,
  value: "COLLECT"
}
const _hoisted_49 = {
  key: 0,
  class: "row"
}
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "d-block text-black fw-semibold mb-10" }
const _hoisted_52 = { value: "" }
const _hoisted_53 = ["value"]
const _hoisted_54 = { class: "modal-footer" }
const _hoisted_55 = {
  key: 0,
  type: "submit",
  class: "btn text-white",
  style: {"background-color":"#EB9355"}
}

import {ref, onMounted,reactive,inject, computed } from "vue";
import axios from 'axios';
import flatpickr from "flatpickr";
import { useRoute, useRouter } from 'vue-router'
import conf from '../../../env.json'
import { useI18n } from "vue-i18n";
import router from '../../router/index'
import {showToast,checkSessionValidate} from "../../utils/function";
import {current_permissions} from '../../utils/permission';
import {Account,User} from "@/utils/Model";
import * as yup from 'yup';
const leadPlaceholder = "Select Lead Date";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AccountContentByCompany',
  setup(__props) {

const backApi=inject('back');
const selectedType = ref('PAYOUT');
let edit = 0;
let itemCode = '';
const errors = ref('');  
const success = ref('');
const errorId=ref('');
const errorsBis = {'name':''};
const pageLoad = ref(false);
const role=ref('');
const selectedUser = ref('');
const users = ref(new Array<User>());
const token =  localStorage.getItem('login_token');
const { t } = useI18n();
role.value =  localStorage.getItem('role');
const userCode =  localStorage.getItem('code');
let codeOrganization: string|null = localStorage.getItem('organization_code');
const accounts =ref(new Array<Account>());
const total = ref(0);

const isAuthorizedRole = computed(() => {
  return role.value === 'SUPERADMIN' || role.value === 'BUSINESS' || role.value === 'SUPPORT';
});

function handleUserChange(event) {
  selectedUser.value = event.target.value;
}

function handleTypeChange(event){
  selectedType.value = event.target.value;
}

const initField = () =>{
  formValues.name=  ''; 
  selectedType.value = 'PAYOUT'; 
  itemCode = '';
  edit=0;
  errorId.value=''
  errors.value=''
}

const save =()=>{
  if (edit==0){
    storeAccount()
  }else{
    updateUser()    
  }
  
}

  const formValues = reactive({
    name: "",  
    
  });

  
  const schema = yup.object({     
      name: yup.string().required('Le nom complet est requis'),        
  });



function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}
let code: string | null = '';

onMounted(() => {
  checkSessionValidate(1);

  flatpickr("#lead-calendar", {
    altInput: true,
    altFormat: "F j, Y",
    dateFormat: "Y-m-d",
    defaultDate: "today",
  });

  flatpickr("#basic-calendar", {
    dateFormat: "Y-m-d H:i",
  });

  const route = useRoute();

  code = route.params.id as string;

  const organizationCode =
    role.value === "SUPERADMIN" ||
    role.value === "BUSINESS" ||
    role.value === "SUPPORT"
      ? code
      : codeOrganization;

  getUsers(organizationCode);
  getAccounts(organizationCode);

  setTimeout(() => {
    pageLoad.value = true;
  }, 1000);
});

const getUsers = (code) =>{

const urlUsers = isAuthorizedRole.value
  ? `${backApi}/secure/users/extended/?organization=${code}`
  : `${backApi}/secure/users/?organization=${code}`;

axios.get(urlUsers,{
      headers: {
          Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
      // users.value = response.data;
      users.value = response.data;  //.data.users          
      // console.log(users.value);
      
      
  }).catch((error) => {
        if( error.response){
            console.log(error.response.data); // => the response payload 
            if(error.response.status === 401){
              router.push('/')
              //window.location.href = '/';
            }   
            
        }
});
}
const getAccounts = (code) =>{

  const urlAccounts = isAuthorizedRole.value
    ? `${backApi}/secure/merchants/extended/?organization=${code}`
    : `${backApi}/secure/merchants/?organization=${code}`;

  axios.get(urlAccounts,{
        headers: {
            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        accounts.value = response.data.data;
        total.value = response.data.pagination?.total ?? accounts.value.length;
        // console.log(accounts.value);
        
        
    }).catch((error) => {
          if( error.response){
              console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                //window.location.href = '/';
              }   
              
          }
  });
}


const storeAccount =()=>{
try {  selectedUser
  schema.validateSync(formValues);
  axios.post(`${backApi}/secure/merchants/all`,{
          //name:formValues.name,
          //type:selectedType.value,
          //merchantType: null,
          //provider: formValues.name,
          //balance: 0,
          organization:code,
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){   
          showToast("Compte de type "+selectedType.value.toLowerCase()+" enregistré avec succès","green");   
          formValues.name='';
          selectedType.value='';
          // router.go();  
        }      
        
    }).catch((error) => {
          if( error.response){
              //console.log(error.response.data); // => the response payload 
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }       
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}


}

const updateUser =()=>{
try {  
  schema.validateSync(formValues);
  axios.put(`${backApi}/secure/users/${itemCode}/edit`,{
          name:formValues.name,
          // role:selectedRole.value,
          // status:selectedValidation.value,
          // email:formValues.email,
          // password:formValues.password,
          organization:code,
          code:itemCode,
          type:'API',
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        if(response.status === 200){   
          showToast("Utilisaeur modifié avec succès","green");   
          router.go();  
        }      
        
    }).catch((error) => {
          if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              }    
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}


}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}

const changeStatus =(status,code)=>{
  axios.post(`${backApi}/secure/accounts/status`,{
          code: code,
          status:  (status=='ACTIVE')?'INACTIVE':'ACTIVE'
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
      }       
      }).then((response) => {  
        showToast("Statut du compte modifié avec succès","green");      
        router.go();        
        
    }).catch((error) => {
          if( error.response){
              
              showToast(error.response.data.message,"red"); 
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("div", {
            class: "spinner-grow text-danger",
            style: {"width":"3rem","height":"3rem","margin-top":"25vh","margin-left":"42%","margin-bottom":"5vh"},
            role: "status"
          }, [
            _createElementVNode("span", { class: "visually-hidden" }, "Loading...")
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (pageLoad.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_unref(current_permissions)('create_account'))
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0",
                    type: "button",
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#companyModal",
                    style: {"background-color":"#EB9355"},
                    onClick: initField
                  }, [
                    _createTextVNode(_toDisplayString(role.value == 'ADMIN' ? _ctx.$t('accounts.createSubAccount') : _ctx.$t('accounts.createAccount')) + " ", 1),
                    _cache[4] || (_cache[4] = _createElementVNode("i", { class: "flaticon-plus position-relative ms-5 fs-12" }, null, -1))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "d-sm-flex align-items-center" }, [
              _createElementVNode("div", { class: "select-calendar position-relative me-sm-10 ms-sm-15 mt-10 mt-sm-0" })
            ], -1))
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("table", _hoisted_7, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('accounts.id')), 1),
                    _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('accounts.name')), 1),
                    _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t('accounts.type')), 1),
                    _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t('accounts.attachedTo')), 1),
                    _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t('accounts.status')), 1),
                    _cache[6] || (_cache[6] = _createElementVNode("th", {
                      scope: "col",
                      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
                    }, null, -1))
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts.value, (account) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: account.code
                    }, [
                      _createElementVNode("th", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "form-check mb-0" }, [
                            _createElementVNode("input", {
                              class: "form-check-input shadow-none",
                              type: "checkbox"
                            })
                          ], -1)),
                          _createElementVNode("div", _hoisted_15, _toDisplayString(account.code), 1)
                        ])
                      ]),
                      _createElementVNode("td", _hoisted_16, _toDisplayString(account.name), 1),
                      _createElementVNode("td", _hoisted_17, _toDisplayString(account.merchantAccountType), 1),
                      _createElementVNode("td", _hoisted_18, _toDisplayString(account.user?.name || account.organization?.name), 1),
                      _createElementVNode("td", _hoisted_19, [
                        (account.status==='ACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.$t('accounts.active')), 1))
                          : _createCommentVNode("", true),
                        (account.status==='INACTIVE')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(_ctx.$t('accounts.inactive')), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("td", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _cache[9] || (_cache[9] = _createElementVNode("button", {
                            class: "dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition",
                            type: "button",
                            "data-bs-toggle": "dropdown",
                            "aria-expanded": "false"
                          }, [
                            _createElementVNode("i", { class: "flaticon-dots" })
                          ], -1)),
                          _createElementVNode("ul", _hoisted_24, [
                            _createElementVNode("li", null, [
                              (_unref(current_permissions)('post_account_status'))
                                ? (_openBlock(), _createElementBlock("a", {
                                    key: 0,
                                    class: "dropdown-item d-flex align-items-center",
                                    href: "javascript:void(0);",
                                    onClick: ($event: any) => (changeStatus(account.status,account.code))
                                  }, [
                                    _cache[8] || (_cache[8] = _createElementVNode("i", { class: "flaticon-logout lh-1 me-8 position-relative top-1" }, null, -1)),
                                    (account.status==='ACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.$t('accounts.deactivate')), 1))
                                      : _createCommentVNode("", true),
                                    (account.status==='INACTIVE')
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.$t('accounts.activate')), 1))
                                      : _createCommentVNode("", true)
                                  ], 8, _hoisted_25))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("form", {
            onSubmit: _withModifiers(save, ["prevent"])
          }, [
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("h1", _hoisted_32, _toDisplayString(_unref(edit) == 0 ? _ctx.$t('accounts.createAccountTitle') : _ctx.$t('accounts.editAccountTitle')), 1),
              _cache[10] || (_cache[10] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_33, [
              (errors.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                    _createElementVNode("h6", _hoisted_35, _toDisplayString(errorId.value), 1),
                    _createElementVNode("h6", _hoisted_36, _toDisplayString(errors.value), 1)
                  ]))
                : _createCommentVNode("", true),
              (success.value!=='')
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                    _createElementVNode("h6", _hoisted_38, _toDisplayString(success.value), 1)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("div", _hoisted_40, [
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('accounts.accountName')), 1),
                    _createElementVNode("div", null, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formValues.name) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16", { 'is-invalid': errorsBis['name'] }]),
                        placeholder: _ctx.$t('accounts.accountNamePlaceholder'),
                        onBlur: _cache[1] || (_cache[1] = ($event: any) => (validate('name'))),
                        onKeyup: _cache[2] || (_cache[2] = ($event: any) => (validate('name')))
                      }, null, 42, _hoisted_43), [
                        [_vModelText, formValues.name]
                      ]),
                      _createElementVNode("span", _hoisted_44, _toDisplayString(errorsBis['name']), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('accounts.accountType')), 1),
                    _createElementVNode("div", null, [
                      _createElementVNode("select", {
                        name: "role",
                        id: "role",
                        class: "form-select fs-md-15 text-black shadow-none",
                        onChange: handleTypeChange,
                        required: ""
                      }, [
                        _cache[11] || (_cache[11] = _createElementVNode("option", { value: "PAYOUT" }, "PAYOUT", -1)),
                        (role.value=='SUPERADMIN')
                          ? (_openBlock(), _createElementBlock("option", _hoisted_47, "AVAILABLE"))
                          : _createCommentVNode("", true),
                        (role.value=='SUPERADMIN')
                          ? (_openBlock(), _createElementBlock("option", _hoisted_48, "COLLECT"))
                          : _createCommentVNode("", true)
                      ], 32)
                    ])
                  ])
                ]),
                (role.value=='ADMIN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                      _createElementVNode("div", _hoisted_50, [
                        _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('accounts.users')), 1),
                        _createElementVNode("select", {
                          name: "mode",
                          id: "mode",
                          class: "form-select fs-md-15 text-black shadow-none",
                          onChange: handleUserChange
                        }, [
                          _createElementVNode("option", _hoisted_52, _toDisplayString(_ctx.$t('accounts.select')), 1),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(users.value, (user) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: user.code,
                              key: user.code
                            }, _toDisplayString(user.name), 9, _hoisted_53))
                          }), 128))
                        ], 32)
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_54, [
              (_unref(current_permissions)('create_account'))
                ? (_openBlock(), _createElementBlock("button", _hoisted_55, [
                    _cache[12] || (_cache[12] = _createElementVNode("i", {
                      class: "flaticon-plus position-relative ms-5 fs-12",
                      style: {"color":"#FFF"}
                    }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('accounts.save')), 1)
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 32)
        ])
      ])
    ]),
    _cache[13] || (_cache[13] = _createElementVNode("div", { id: "snackbar" }, null, -1))
  ], 64))
}
}

})